import type { PersonalLoanSort } from "../Calculator/types";
import type { LoanGoal } from "../LeadForm/types";

export const MAX_TOTAL_INCOME = 10_000_000;

export const INITIAL_VALUES = {
	loanAmount: undefined,
	maturityYears: undefined,
	incomeList: [
		{
			incomeType: "SALARY-H",
			incomeTypeName: "Magyar alkalmazotti jövedelem",
			amount: undefined,
			receiptAmount: undefined,
			durationMonths: 12,
			isCash: false,
		},
	],
	employmentMonths: 12,
	loanGoals: ["SZABAD_FELHASZNALAS" as LoanGoal],
	fasterAdministration: undefined,
	activeBankContact: true,
	age: 30,
	comparator: "APR" as PersonalLoanSort,
	hasPermanentHungarianAddress: true,
	roleCode: "BM",
};
